module.exports = __webpack_public_path__ + "img/gq.2f5039e9.svg";